import {
  IonAccordion,
  IonAccordionGroup,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonNote
} from '@ionic/react';

import './PermissionView.module.scss';

import { Permission } from '../../types/services.types';

export interface PermissionViewProps {
  permissions: Permission[];
  tokenInput: boolean;
  tokenName: string;
  tokenUrl?: string;
}

export const PermissionView = ({
  permissions,
  tokenInput,
  tokenName,
  tokenUrl
}: PermissionViewProps) => (
  <>
    {permissions.map((permission) => (
      <IonItem key={permission.id} lines="none">
        <IonIcon
          icon={permission.icon}
          src={permission.iconUrl}
          slot="start"
        ></IonIcon>
        {permission.scopes ? (
          <IonAccordionGroup multiple={true} style={{ width: '100%' }}>
            {permission.scopes.map((scope) => (
              <IonAccordion key={scope.id} value={scope.id}>
                <IonItem slot="header" lines="inset">
                  <IonIcon icon={scope.icon}></IonIcon>
                  <IonLabel class="ion-text-wrap">
                    <h2>{scope.title}</h2>
                    <IonNote>{scope.subtitle}</IonNote>
                  </IonLabel>
                </IonItem>
                <div className="ion-padding description" slot="content">
                  {scope.descriptionHTML && (
                    <p
                      className="description"
                      dangerouslySetInnerHTML={{
                        __html: scope.descriptionHTML
                      }}
                    ></p>
                  )}
                </div>
              </IonAccordion>
            ))}

            {tokenInput && (
              <IonItem lines="none" key="create-token">
                <IonLabel class="create-container">
                  <IonButton
                    color="primary"
                    fill="solid"
                    expand="block"
                    target="_blank"
                    href={tokenUrl}
                  >
                    Create {tokenName.toLowerCase()} with these scopes
                  </IonButton>
                </IonLabel>
              </IonItem>
            )}
          </IonAccordionGroup>
        ) : (
          <IonLabel text-wrap>
            {permission.title && (
              <h2
                dangerouslySetInnerHTML={{
                  __html: permission.title
                }}
              ></h2>
            )}
            {permission.subtitle && <p>{permission.subtitle}</p>}
            {permission.descriptionHTML && (
              <p
                className="description"
                dangerouslySetInnerHTML={{ __html: permission.descriptionHTML }}
              ></p>
            )}
          </IonLabel>
        )}
      </IonItem>
    ))}
  </>
);
